import React from 'react';
import { useSelector } from 'react-redux';
import { isKzUrl } from 'utils';
import { getHost } from 'selectors';
import { KzInstore } from 'containers/instore/instore-service/components/kz-instores';
import { InstoreService, InstoreServicesList } from '../../containers/instore';
import { SEOText } from '../../common/components';
import { useInstorePage } from './hooks';

export const InstorePage = () => {
	const { categoryId } = useInstorePage();
	const host = useSelector(getHost);
	return (
		<div className="services-landings__content">
			{isKzUrl(host) ? (
				<KzInstore />
			) : (
				<>
					{categoryId ? <InstoreService /> : <InstoreServicesList />}
					<SEOText />
				</>
			)}
		</div>
	);
};
